import React, { useCallback } from "react";
import { Row, Col, Button, Result } from "antd";
import { push } from "connected-react-router";
import { connect, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

import CalculationTitle from "./calculationTitle";
import NonEuWarning from "../calculationForm/nonEuWarning";
import { defaultAdr } from "../../consignment/servicesForm/adr";
import { CONSIGNMENT_REQUEST_SET } from "../../../modules/redux/actionNames";

function ResultDisplay({ push, nonEu, result, formData, isSlovakia }) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const handleClick = useCallback(() => {
    dispatch({
      type: CONSIGNMENT_REQUEST_SET,
      consignment: {
        productId: formData.productId,
        product: {
          id: formData.productId,
        },
        deliveryAddress: {
          countryId: formData.deliveryCountryId,
          zipCode: formData.deliveryZipCode,
        },
        pickupAddress: {
          countryId: formData.pickupCountryId,
          zipCode: formData.pickupZipCode,
        },
        collis: formData.collis.map((c, idx) => ({
          key: idx,
          length: c.length,
          height: c.height,
          width: c.width,
          weight: c.weight,
          wrappingId: c.wrappingId,
          stackable: c.stackable,
          loadingMeters: c.loadingMeters,
        })),
        services: {
          adr: formData.adr ? defaultAdr : undefined,
          carryToFloor: formData.carryToFloor,
          transportOldAppliance: formData.transportOldAppliance,
          cashOnDelivery:
            formData.cashOnDeliveryAmount && formData.cashOnDeliveryCurrencyId
              ? {
                  amount: formData.cashOnDeliveryAmount,
                  currencyId: formData.cashOnDeliveryCurrencyId,
                }
              : undefined,
          insurance:
            formData.insurance > 0 && formData.insuranceCurrencyId
              ? true
              : false,
          consignmentPrice: formData.insurance,
          consignmentPriceCurrencyId: formData.insuranceCurrencyId,
          timeSlotBooking: formData.timeSlotBooking,
          euroPalletCount: formData.palletCount,
          incotermId: formData.incotermId,
        },
      },
    });
    push("/new-consignment");
  }, [push, formData, dispatch]);

  return (
    <Row>
      <Col className="center">
        {result ? (
          result === "e" ? (
            <Result
              status="error"
              title={intl.formatMessage({
                id: "calculator.error",
                defaultMessage: "Při výpočtu ceny nastala chyba!",
              })}
            />
          ) : result === "v" ? (
            <Result
              status="warning"
              title={intl.formatMessage({
                id: "calculator.checkValues",
                defaultMessage: "Zkontrolujte prosím zadané hodnoty",
              })}
            />
          ) : typeof result === "string" ? (
            <Result status="warning" title={result} />
          ) : (
            <Row>
              <Col>
                {nonEu && <NonEuWarning />}
                <Row>
                  <Col>
                    <Result
                      status={result.price ? "success" : "warning"}
                      title={
                        <CalculationTitle
                          detailed
                          price={result.price}
                          isSlovakia={isSlovakia}
                          priceCurrency={result.currency}
                          items={result.calculationItems}
                        />
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button type="primary" onClick={handleClick}>
                      {intl.formatMessage({
                        id: "calculator.order",
                        defaultMessage: "Objednat přepravu",
                      })}
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          )
        ) : (
          <Result
            status="warning"
            title={intl.formatMessage({
              id: "calculator.emptyValues",
              defaultMessage:
                "Nutno vyplnit povinná pole a kliknout na tlačítko Spočítat",
            })}
          />
        )}
      </Col>
    </Row>
  );
}

export default connect(null, { push })(ResultDisplay);
